export const topupPageTranslations = {
  en: {
    'topup.back': 'Back',
    'topup.title': 'Add Funds',
    'topup.subtitle': 'Top up your balance to create tokens and make payments',
    'topup.currentBalance': 'Current Balance',
    'topup.selectAmount': 'Select Amount',
    'topup.selectAmountDesc': 'Choose a quick amount or enter a custom value',
    'topup.currency': 'Currency',
    'topup.quickSelect': 'Quick Select',
    'topup.customAmount': 'Custom Amount',
    'topup.enterAmount': 'Enter amount',
    'topup.addFunds': 'Add Funds',
    'topup.whyAddFunds': 'Why Add Funds?',
    'topup.instantCreation': 'Instant Token Creation',
    'topup.instantCreationDesc': 'Create cash and invoice tokens instantly without payment delays',
    'topup.betterRates': 'Better Rates',
    'topup.betterRatesDesc': 'Save on transaction fees by funding your account in advance',
    'topup.multipleCurrencies': 'Multiple Currencies',
    'topup.multipleCurrenciesDesc': 'Hold balances in multiple currencies for international payments',
    'topup.securePayment': 'Secure Payment:',
    'topup.securePaymentDesc': 'All payment methods including Apple Pay, Google Pay, cards, and PayPal are supported with bank-level encryption.',
    'topup.toast.errorLoading': 'Failed to load balance information',
    'topup.toast.success': 'Successfully added {amount} {currency} to your balance!',
    'topup.toast.errorCompleting': 'Failed to complete top-up',
    'topup.toast.invalidAmount': 'Please enter a valid amount',
  },
  es: {
    'topup.back': 'Atrás',
    'topup.title': 'Añadir Fondos',
    'topup.subtitle': 'Recarga tu saldo para crear tokens y realizar pagos',
    'topup.currentBalance': 'Saldo Actual',
    'topup.selectAmount': 'Seleccionar Cantidad',
    'topup.selectAmountDesc': 'Elige una cantidad rápida o introduce un valor personalizado',
    'topup.currency': 'Moneda',
    'topup.quickSelect': 'Selección Rápida',
    'topup.customAmount': 'Cantidad Personalizada',
    'topup.enterAmount': 'Introduce la cantidad',
    'topup.addFunds': 'Añadir Fondos',
    'topup.whyAddFunds': '¿Por qué añadir fondos?',
    'topup.instantCreation': 'Creación Instantánea de Tokens',
    'topup.instantCreationDesc': 'Crea tokens de efectivo y facturas al instante sin retrasos en el pago',
    'topup.betterRates': 'Mejores Tarifas',
    'topup.betterRatesDesc': 'Ahorra en comisiones por transacción financiando tu cuenta por adelantado',
    'topup.multipleCurrencies': 'Múltiples Monedas',
    'topup.multipleCurrenciesDesc': 'Mantén saldos en múltiples monedas para pagos internacionales',
    'topup.securePayment': 'Pago Seguro:',
    'topup.securePaymentDesc': 'Todos los métodos de pago, incluyendo Apple Pay, Google Pay, tarjetas y PayPal, son compatibles con encriptación de nivel bancario.',
    'topup.toast.errorLoading': 'No se pudo cargar la información del saldo',
    'topup.toast.success': '¡Se han añadido {amount} {currency} a tu saldo con éxito!',
    'topup.toast.errorCompleting': 'No se pudo completar la recarga',
    'topup.toast.invalidAmount': 'Por favor, introduce una cantidad válida',
  },
  fr: {
    'topup.back': 'Retour',
    'topup.title': 'Ajouter des fonds',
    'topup.subtitle': 'Rechargez votre solde pour créer des tokens et effectuer des paiements',
    'topup.currentBalance': 'Solde actuel',
    'topup.selectAmount': 'Sélectionner le montant',
    'topup.selectAmountDesc': 'Choisissez un montant rapide ou entrez une valeur personnalisée',
    'topup.currency': 'Devise',
    'topup.quickSelect': 'Sélection rapide',
    'topup.customAmount': 'Montant personnalisé',
    'topup.enterAmount': 'Entrez le montant',
    'topup.addFunds': 'Ajouter des fonds',
    'topup.whyAddFunds': 'Pourquoi ajouter des fonds ?',
    'topup.instantCreation': 'Création instantanée de tokens',
    'topup.instantCreationDesc': 'Créez des tokens de paiement et de facture instantanément sans délais de paiement',
    'topup.betterRates': 'Meilleurs tarifs',
    'topup.betterRatesDesc': 'Économisez sur les frais de transaction en finançant votre compte à l\'avance',
    'topup.multipleCurrencies': 'Plusieurs devises',
    'topup.multipleCurrenciesDesc': 'Maintenez des soldes en plusieurs devises pour les paiements internationaux',
    'topup.securePayment': 'Paiement sécurisé :',
    'topup.securePaymentDesc': 'Tous les modes de paiement, y compris Apple Pay, Google Pay, cartes et PayPal, sont pris en charge avec un chiffrement de niveau bancaire.',
    'topup.toast.errorLoading': 'Échec du chargement des informations de solde',
    'topup.toast.success': '{amount} {currency} ajouté avec succès à votre solde !',
    'topup.toast.errorCompleting': 'Échec de la finalisation de la recharge',
    'topup.toast.invalidAmount': 'Veuillez entrer un montant valide',
  },
  sq: {
    'topup.back': 'Kthehu',
    'topup.title': 'Shto Fonde',
    'topup.subtitle': 'Rimbushni bilancin tuaj për të krijuar tokena dhe bërë pagesa',
    'topup.currentBalance': 'Bilanci Aktual',
    'topup.selectAmount': 'Zgjidhni Shumën',
    'topup.selectAmountDesc': 'Zgjidhni një shumë të shpejtë ose shkruani një vlerë të personalizuar',
    'topup.currency': 'Monedha',
    'topup.quickSelect': 'Zgjedhje e Shpejtë',
    'topup.customAmount': 'Shumë e Personalizuar',
    'topup.enterAmount': 'Shkruani shumën',
    'topup.addFunds': 'Shto Fonde',
    'topup.whyAddFunds': 'Pse të Shtoni Fonde?',
    'topup.instantCreation': 'Krijim i Menjëhershëm i Tokenit',
    'topup.instantCreationDesc': 'Krijoni tokena parash dhe faturash menjëherë pa vonesa në pagesë',
    'topup.betterRates': 'Tarifa Më të Mira',
    'topup.betterRatesDesc': 'Kurseni në tarifat e transaksioneve duke financuar llogarinë tuaj paraprakisht',
    'topup.multipleCurrencies': 'Monedha të Shumta',
    'topup.multipleCurrenciesDesc': 'Mbani bilance në monedha të shumta për pagesa ndërkombëtare',
    'topup.securePayment': 'Pagesë e Sigurt:',
    'topup.securePaymentDesc': 'Të gjitha metodat e pagesës duke përfshirë Apple Pay, Google Pay, kartat dhe PayPal mbështeten me enkriptim të nivelit bankar.',
    'topup.toast.errorLoading': 'Dështoi ngarkimi i informacionit të bilancit',
    'topup.toast.success': 'U shtua me sukses {amount} {currency} në bilancin tuaj!',
    'topup.toast.errorCompleting': 'Dështoi përfundimi i rimbushjes',
    'topup.toast.invalidAmount': 'Ju lutemi shkruani një shumë të vlefshme',
  },
  ru: {
    'topup.back': 'Назад',
    'topup.title': 'Пополнить баланс',
    'topup.subtitle': 'Пополните баланс для создания токенов и совершения платежей',
    'topup.currentBalance': 'Текущий баланс',
    'topup.selectAmount': 'Выберите сумму',
    'topup.selectAmountDesc': 'Выберите быструю сумму или введите пользовательское значение',
    'topup.currency': 'Валюта',
    'topup.quickSelect': 'Быстрый выбор',
    'topup.customAmount': 'Пользовательская сумма',
    'topup.enterAmount': 'Введите сумму',
    'topup.addFunds': 'Пополнить баланс',
    'topup.whyAddFunds': 'Зачем пополнять баланс?',
    'topup.instantCreation': 'Мгновенное создание токенов',
    'topup.instantCreationDesc': 'Создавайте токены наличных и счетов мгновенно без задержек в оплате',
    'topup.betterRates': 'Лучшие тарифы',
    'topup.betterRatesDesc': 'Экономьте на комиссиях за транзакции, пополняя счет заранее',
    'topup.multipleCurrencies': 'Множественные валюты',
    'topup.multipleCurrenciesDesc': 'Храните балансы в нескольких валютах для международных платежей',
    'topup.securePayment': 'Безопасная оплата:',
    'topup.securePaymentDesc': 'Все методы оплаты, включая Apple Pay, Google Pay, карты и PayPal, поддерживаются с шифрованием банковского уровня.',
    'topup.toast.errorLoading': 'Не удалось загрузить информацию о балансе',
    'topup.toast.success': 'Успешно добавлено {amount} {currency} на ваш баланс!',
    'topup.toast.errorCompleting': 'Не удалось завершить пополнение',
    'topup.toast.invalidAmount': 'Пожалуйста, введите действительную сумму',
  },
  pt: {
    'topup.back': 'Voltar',
    'topup.title': 'Adicionar Fundos',
    'topup.subtitle': 'Recarregue seu saldo para criar tokens e fazer pagamentos',
    'topup.currentBalance': 'Saldo Atual',
    'topup.selectAmount': 'Selecionar Valor',
    'topup.selectAmountDesc': 'Escolha um valor rápido ou insira um valor personalizado',
    'topup.currency': 'Moeda',
    'topup.quickSelect': 'Seleção Rápida',
    'topup.customAmount': 'Valor Personalizado',
    'topup.enterAmount': 'Insira o valor',
    'topup.addFunds': 'Adicionar Fundos',
    'topup.whyAddFunds': 'Por que Adicionar Fundos?',
    'topup.instantCreation': 'Criação Instantânea de Tokens',
    'topup.instantCreationDesc': 'Crie tokens de dinheiro e fatura instantaneamente sem atrasos de pagamento',
    'topup.betterRates': 'Melhores Taxas',
    'topup.betterRatesDesc': 'Economize em taxas de transação financiando sua conta antecipadamente',
    'topup.multipleCurrencies': 'Múltiplas Moedas',
    'topup.multipleCurrenciesDesc': 'Mantenha saldos em múltiplas moedas para pagamentos internacionais',
    'topup.securePayment': 'Pagamento Seguro:',
    'topup.securePaymentDesc': 'Todos os métodos de pagamento, incluindo Apple Pay, Google Pay, cartões e PayPal, são suportados com criptografia de nível bancário.',
    'topup.toast.errorLoading': 'Falha ao carregar informações do saldo',
    'topup.toast.success': 'Adicionado com sucesso {amount} {currency} ao seu saldo!',
    'topup.toast.errorCompleting': 'Falha ao completar recarga',
    'topup.toast.invalidAmount': 'Por favor, insira um valor válido',
  },
  el: {
    'topup.back': 'Πίσω',
    'topup.title': 'Προσθήκη Χρημάτων',
    'topup.subtitle': 'Ανανεώστε το υπόλοιπό σας για να δημιουργήσετε tokens και να κάνετε πληρωμές',
    'topup.currentBalance': 'Τρέχον Υπόλοιπο',
    'topup.selectAmount': 'Επιλογή Ποσού',
    'topup.selectAmountDesc': 'Επιλέξτε ένα γρήγορο ποσό ή εισάγετε μια προσαρμοσμένη τιμή',
    'topup.currency': 'Νόμισμα',
    'topup.quickSelect': 'Γρήγορη Επιλογή',
    'topup.customAmount': 'Προσαρμοσμένο Ποσό',
    'topup.enterAmount': 'Εισάγετε ποσό',
    'topup.addFunds': 'Προσθήκη Χρημάτων',
    'topup.whyAddFunds': 'Γιατί να Προσθέσετε Χρήματα;',
    'topup.instantCreation': 'Άμεση Δημιουργία Tokens',
    'topup.instantCreationDesc': 'Δημιουργήστε tokens μετρητών και τιμολογίων άμεσα χωρίς καθυστερήσεις πληρωμής',
    'topup.betterRates': 'Καλύτερες Τιμές',
    'topup.betterRatesDesc': 'Εξοικονομήστε σε τέλη συναλλαγών χρηματοδοτώντας τον λογαριασμό σας εκ των προτέρων',
    'topup.multipleCurrencies': 'Πολλαπλά Νομίσματα',
    'topup.multipleCurrenciesDesc': 'Κρατήστε υπολοίπα σε πολλαπλά νομίσματα για διεθνείς πληρωμές',
    'topup.securePayment': 'Ασφαλής Πληρωμή:',
    'topup.securePaymentDesc': 'Όλοι οι τρόποι πληρωμής, συμπεριλαμβανομένων του Apple Pay, Google Pay, καρτών και PayPal, υποστηρίζονται με κρυπτογράφηση επιπέδου τράπεζας.',
    'topup.toast.errorLoading': 'Αποτυχία φόρτωσης πληροφοριών υπολοίπου',
    'topup.toast.success': 'Προστέθηκαν με επιτυχία {amount} {currency} στο υπόλοιπό σας!',
    'topup.toast.errorCompleting': 'Αποτυχία ολοκλήρωσης ανανέωσης',
    'topup.toast.invalidAmount': 'Παρακαλώ εισάγετε ένα έγκυρο ποσό',
  },
  de: {
    'topup.back': 'Zurück',
    'topup.title': 'Guthaben aufladen',
    'topup.subtitle': 'Laden Sie Ihr Guthaben auf, um Tokens zu erstellen und Zahlungen zu tätigen',
    'topup.currentBalance': 'Aktuelles Guthaben',
    'topup.selectAmount': 'Betrag auswählen',
    'topup.selectAmountDesc': 'Wählen Sie einen Schnellbetrag oder geben Sie einen benutzerdefinierten Wert ein',
    'topup.currency': 'Währung',
    'topup.quickSelect': 'Schnellauswahl',
    'topup.customAmount': 'Benutzerdefinierter Betrag',
    'topup.enterAmount': 'Betrag eingeben',
    'topup.addFunds': 'Guthaben aufladen',
    'topup.whyAddFunds': 'Warum Guthaben aufladen?',
    'topup.instantCreation': 'Sofortige Token-Erstellung',
    'topup.instantCreationDesc': 'Erstellen Sie Cash- und Rechnungs-Tokens sofort ohne Zahlungsverzögerungen',
    'topup.betterRates': 'Bessere Konditionen',
    'topup.betterRatesDesc': 'Sparen Sie Transaktionsgebühren, indem Sie Ihr Konto im Voraus aufladen',
    'topup.multipleCurrencies': 'Mehrere Währungen',
    'topup.multipleCurrenciesDesc': 'Halten Sie Guthaben in mehreren Währungen für internationale Zahlungen',
    'topup.securePayment': 'Sichere Zahlung:',
    'topup.securePaymentDesc': 'Alle Zahlungsmethoden einschließlich Apple Pay, Google Pay, Karten und PayPal werden mit Bank-Level-Verschlüsselung unterstützt.',
    'topup.toast.errorLoading': 'Guthabeninformationen konnten nicht geladen werden',
    'topup.toast.success': 'Erfolgreich {amount} {currency} zu Ihrem Guthaben hinzugefügt!',
    'topup.toast.errorCompleting': 'Aufladung konnte nicht abgeschlossen werden',
    'topup.toast.invalidAmount': 'Bitte geben Sie einen gültigen Betrag ein',
  },
  ro: {
    'topup.back': 'Înapoi',
    'topup.title': 'Adaugă Fonduri',
    'topup.subtitle': 'Încărcați-vă soldul pentru a crea tokenuri și a face plăți',
    'topup.currentBalance': 'Sold Actual',
    'topup.selectAmount': 'Selectează Suma',
    'topup.selectAmountDesc': 'Alegeți o sumă rapidă sau introduceți o valoare personalizată',
    'topup.currency': 'Monedă',
    'topup.quickSelect': 'Selectare Rapidă',
    'topup.customAmount': 'Sumă Personalizată',
    'topup.enterAmount': 'Introduceți suma',
    'topup.addFunds': 'Adaugă Fonduri',
    'topup.whyAddFunds': 'De ce să Adaugi Fonduri?',
    'topup.instantCreation': 'Creare Instantanee Tokenuri',
    'topup.instantCreationDesc': 'Creați tokenuri de bani și facturi instantaneu fără întârzieri de plată',
    'topup.betterRates': 'Rate Mai Bune',
    'topup.betterRatesDesc': 'Economisiți la taxele de tranzacție finanțând contul în avans',
    'topup.multipleCurrencies': 'Mai Multe Monede',
    'topup.multipleCurrenciesDesc': 'Mențineți solduri în mai multe monede pentru plăți internaționale',
    'topup.securePayment': 'Plată Sigură:',
    'topup.securePaymentDesc': 'Toate metodele de plată, inclusiv Apple Pay, Google Pay, carduri și PayPal, sunt suportate cu criptare de nivel bancar.',
    'topup.toast.errorLoading': 'Nu s-au putut încărca informațiile despre sold',
    'topup.toast.success': 'Adăugat cu succes {amount} {currency} la soldul dvs.!',
    'topup.toast.errorCompleting': 'Nu s-a putut finaliza încărcarea',
    'topup.toast.invalidAmount': 'Vă rugăm să introduceți o sumă validă',
  },
  sr: {
    'topup.back': 'Назад',
    'topup.title': 'Додај средства',
    'topup.subtitle': 'Допуните своје стање да бисте креирали токене и вршили плаћања',
    'topup.currentBalance': 'Тренутно стање',
    'topup.selectAmount': 'Изаберите износ',
    'topup.selectAmountDesc': 'Изаберите брзи износ или унесите прилагођену вредност',
    'topup.currency': 'Валута',
    'topup.quickSelect': 'Брзи избор',
    'topup.customAmount': 'Прилагођени износ',
    'topup.enterAmount': 'Унесите износ',
    'topup.addFunds': 'Додај средства',
    'topup.whyAddFunds': 'Зашто додати средства?',
    'topup.instantCreation': 'Тренутно креирање токена',
    'topup.instantCreationDesc': 'Креирајте кеш и фактурне токене тренутно без кашњења у плаћању',
    'topup.betterRates': 'Боље стопе',
    'topup.betterRatesDesc': 'Уштедите на накнадама за трансакције тако што ћете унапред финансирати свој налог',
    'topup.multipleCurrencies': 'Више валута',
    'topup.multipleCurrenciesDesc': 'Држите стања у више валута за међународна плаћања',
    'topup.securePayment': 'Сигурно плаћање:',
    'topup.securePaymentDesc': 'Сви начини плаћања, укључујући Аппле Паy, Гоогле Паy, картице и ПаyПал, подржани су са енкрипцијом на нивоу банке.',
    'topup.toast.errorLoading': 'Није успело учитавање информација о стању',
    'topup.toast.success': 'Успешно сте додали {amount} {currency} на своје стање!',
    'topup.toast.errorCompleting': 'Није успело завршавање допуне',
    'topup.toast.invalidAmount': 'Молимо унесите важећи износ',
  },
  pl: {
    'topup.back': 'Wstecz',
    'topup.title': 'Dodaj Środki',
    'topup.subtitle': 'Dopłać swoje saldo, aby tworzyć tokeny i dokonywać płatności',
    'topup.currentBalance': 'Aktualne Saldo',
    'topup.selectAmount': 'Wybierz Kwotę',
    'topup.selectAmountDesc': 'Wybierz szybką kwotę lub wprowadź niestandardową wartość',
    'topup.currency': 'Waluta',
    'topup.quickSelect': 'Szybki Wybór',
    'topup.customAmount': 'Niestandardowa Kwota',
    'topup.enterAmount': 'Wprowadź kwotę',
    'topup.addFunds': 'Dodaj Środki',
    'topup.whyAddFunds': 'Dlaczego Dodawać Środki?',
    'topup.instantCreation': 'Natychmiastowe Tworzenie Tokenów',
    'topup.instantCreationDesc': 'Twórz tokeny gotówkowe i fakturowe natychmiast bez opóźnień w płatnościach',
    'topup.betterRates': 'Lepsze Stawki',
    'topup.betterRatesDesc': 'Oszczędzaj na opłatach transakcyjnych, finansując swoje konto z wyprzedzeniem',
    'topup.multipleCurrencies': 'Wiele Walut',
    'topup.multipleCurrenciesDesc': 'Utrzymuj salda w wielu walutach dla płatności międzynarodowych',
    'topup.securePayment': 'Bezpieczna Płatność:',
    'topup.securePaymentDesc': 'Wszystkie metody płatności, w tym Apple Pay, Google Pay, karty i PayPal, są obsługiwane z szyfrowaniem na poziomie bankowym.',
    'topup.toast.errorLoading': 'Nie udało się załadować informacji o saldzie',
    'topup.toast.success': 'Pomyślnie dodano {amount} {currency} do Twojego salda!',
    'topup.toast.errorCompleting': 'Nie udało się ukończyć dopłaty',
    'topup.toast.invalidAmount': 'Proszę wprowadzić prawidłową kwotę',
  },
};
